import { useEffect } from "react";

/**
 * Calls `onClose` when Escape is pressed while `isActive` is true.
 * Safe to use in stacked modals — parent should skip when a child modal is open.
 */
export default function useEscapeKeyDown(isActive, onClose, options = {}) {
  const { preventDefault = true } = options;

  useEffect(() => {
    if (!isActive || typeof onClose !== "function") return undefined;

    const handleKeyDown = (e) => {
      if (e.key !== "Escape") return;
      if (preventDefault) e.preventDefault();
      onClose();
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isActive, onClose, preventDefault]);
}
